import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useLoggedInUser } from '../../context/LoggedInUserContext';
import type { RootState } from '../../store';

const TenancyStatusRedirector = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loggedInUser } = useLoggedInUser();
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  useEffect(() => {
    if (!selectedTenancy || !loggedInUser) {
      return;
    }

    const tenancyId = selectedTenancy.tenancy_id;
    const matchingTenancy = loggedInUser.tenancyDetails?.find(
      (detail) => detail.id === tenancyId,
    );

    const userStatus = matchingTenancy?.user_status;

    // Only redirect if status is not 1 and not already on permission-missing page
    if (userStatus !== 1 && location.pathname !== '/permission-missing') {
      navigate('/permission-missing');
    }
  }, [selectedTenancy, loggedInUser, navigate, location.pathname]);

  return null;
};

export default TenancyStatusRedirector;
